(function () {
  if (window.__tckcPrintWarehouse) return;
  window.__tckcPrintWarehouse = true;

  var MEMORY = {};

  function findFormId(root) {
    var scope = root.closest('.shopify-section, product-information, body');
    if (!scope) return null;
    var el = scope.querySelector('form[action*="/cart/add"]');
    var id = el ? el.getAttribute('id') : null;
    return id || null;
  }

  function pickerText(scope) {
    var parts = [];
    scope.querySelectorAll('input[type="radio"]:checked').forEach(function (el) {
      if (el.value) parts.push(el.value);
    });
    scope.querySelectorAll('select').forEach(function (el) {
      if (el.hasAttribute('data-tckc-print-select')) return;
      if (el.value) parts.push(el.value);
    });
    return parts.join(' ').toLowerCase();
  }

  function variantTitle(root) {
    var scope = root.closest('.shopify-section, product-information, body') || document;
    var holder = root.querySelector('[data-tckc-print-variants]');
    if (holder) {
      var map = null;
      try {
        map = JSON.parse(holder.textContent);
      } catch (e) {
        map = null;
      }
      var idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      if (map && idInput && map[idInput.value]) return map[idInput.value];
    }
    return pickerText(scope);
  }

  function reorderGroups(root) {
    var select = root.querySelector('[data-tckc-print-select]');
    if (!select) return;
    var groups = Array.prototype.slice
      .call(select.querySelectorAll('optgroup[data-match]'))
      .filter(function (g) {
        return g.getAttribute('data-match');
      });
    if (groups.length < 2) return;

    var title = variantTitle(root);
    if (!title) return;

    var hits = groups.filter(function (g) {
      return title.indexOf(g.getAttribute('data-match')) !== -1;
    });
    if (hits.length !== 1) return;

    var first = select.querySelector('optgroup');
    if (first && first !== hits[0]) select.insertBefore(hits[0], first);
  }

  function sync(root, remember) {
    var select = root.querySelector('[data-tckc-print-select]');
    var wrap = root.querySelector('[data-tckc-print-custom]');
    if (!select || !wrap) return;

    var input = wrap.querySelector('[data-tckc-print-input]');
    var hintLabel = wrap.querySelector('[data-tckc-print-hint]');
    var option = select.options[select.selectedIndex];
    var needs = !!(option && option.getAttribute('data-custom') === 'true');
    var hint = (option && option.getAttribute('data-hint')) || '';

    wrap.hidden = !needs;
    input.disabled = !needs;
    input.required = needs;

    if (needs) {
      if (hint) {
        input.placeholder = hint;
        if (hintLabel) hintLabel.textContent = hint;
      }
    } else {
      input.value = '';
    }

    var key = root.getAttribute('data-key');
    if (key && remember) {
      MEMORY[key] = { print: select.value, custom: input.value };
    }
  }

  function attachFormIds(root) {
    var formId = findFormId(root);
    if (!formId) return;
    root.querySelectorAll('[data-tckc-print-select], [data-tckc-print-input]').forEach(function (el) {
      if (el.getAttribute('form') !== formId) el.setAttribute('form', formId);
    });
  }

  function restore(root) {
    attachFormIds(root);
    reorderGroups(root);
    var key = root.getAttribute('data-key');
    var saved = key ? MEMORY[key] : null;
    var select = root.querySelector('[data-tckc-print-select]');
    if (saved && select && select.value !== saved.print) {
      select.value = saved.print;
      var input = root.querySelector('[data-tckc-print-input]');
      if (input && saved.custom) input.value = saved.custom;
    }
    sync(root, false);
  }

  function refreshAll() {
    document.querySelectorAll('[data-tckc-print]').forEach(restore);
  }

  // Horizon re-renderiza la seccion al cambiar variante, de forma asincrona y sin
  // avisar. Un solo refresh pierde la carrera: repasamos varias veces.
  function scheduleRefresh() {
    [0, 120, 350, 800, 1500].forEach(function (ms) {
      setTimeout(refreshAll, ms);
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var root = target.closest('[data-tckc-print]');
    if (root) {
      sync(root, true);
      return;
    }
    scheduleRefresh();
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    if (target.closest('[data-tckc-print]')) return;
    if (!target.closest('input[type="radio"], label, .variant-option, fieldset')) return;
    scheduleRefresh();
  });

  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var root = target.closest('[data-tckc-print]');
    if (!root) return;
    var key = root.getAttribute('data-key');
    var select = root.querySelector('[data-tckc-print-select]');
    var input = root.querySelector('[data-tckc-print-input]');
    if (key && select && input) MEMORY[key] = { print: select.value, custom: input.value };
  });

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      refreshAll();
    });
  });

  function boot() {
    refreshAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();